module.exports = __webpack_public_path__ + "ef639339.svg";